import { createFileIcon } from '../createFileIcon/createFileIcon';
import FileIconExeSizeM from './FileIconExe_size_m';
import FileIconExeSizeS from './FileIconExe_size_s';

export const FileIconExe = createFileIcon({
  m: FileIconExeSizeM,
  s: FileIconExeSizeS,
  name: 'FileIconExe',
});
